module.exports = __webpack_public_path__ + "static/media/FruitN'Nuts Cookies 100g.df304958.jpg";